<div class="row mt-4 card-container">
  <div class="col-md-12 d-flex justify-content-center">
    <img
      class="empty-img"
      src="../../../../assets/images/image-gallery/empty.png"
    />
  </div>
  <div class="col-md-12 d-flex justify-content-center">No Data Found</div>
</div>
